import React from 'react';
import { Box, Divider } from '@mui/material';
import Header from '../components/Header';
import Sidebar from '../components/sidebar';
import Breadcrumbs from '../components/BreadCrumbs';
import { useTheme as useMuiTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';

const Layout = ({ children, pageType, toggleTheme ,pendingCount, hideBreadcrumb, overflow }) => {
  const theme = useMuiTheme();
  return (
    <Box sx={{ display: 'flex', height: '100vh', bgcolor: theme.palette.background.default, flexDirection: 'column', overflow: "hidden" }}>
      <Header toggleTheme={toggleTheme} pendingCount={pendingCount}/>
      <Divider />
      <Box sx={{ display: 'flex', flexGrow: 1 }}>
        {pageType === 'sideBar' && <Sidebar sx={{ width: 300 }} />}
        <motion.div
  id="main-scroll-container"  
  initial={{ opacity: 0, x: 20 }}
  animate={{ opacity: 1, x: 0 }}
  transition={{ duration: 0.5, ease: 'easeOut' }}
  style={{
    boxSizing: 'border-box',
    flexGrow: 1,
    padding: "0 10px 10px 10px",
    height: "calc(100vh - 64px)",
    background: theme.customGradients.pageBackground,
    overflow: overflow || 'hidden',
    width: `calc(100vw - ${pageType === 'sideBar' ? '300px' : '0px'})`,
  }}
>
      {!hideBreadcrumb && <Breadcrumbs />}

          {children}
        </motion.div>
      </Box>
    </Box>
    
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  pageType: PropTypes.string,
  toggleTheme: PropTypes.func.isRequired,
  pendingCount: PropTypes.number
};

export default Layout;
